export default __webpack_public_path__ + "static/media/20.4c670e8c.svg";